export enum SortState {
  none,
  asc,
  desc
}
